import { render } from "./SystemDataStatus.vue?vue&type=template&id=5fa7d18e&scoped=true"
import script from "./SystemDataStatus.vue?vue&type=script&lang=js"
export * from "./SystemDataStatus.vue?vue&type=script&lang=js"

import "./SystemDataStatus.vue?vue&type=style&index=0&id=5fa7d18e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa7d18e"]])

export default __exports__